import React, { Component } from "react";
import { Card } from "react-bootstrap";
import logo from "../../media/logo.png";
import moment from "moment";
import settings from "../../settings";
import LoadingSpinner from "./LoadingSpinner";

class FuseCollapsiblePanel extends Component {
  state = {
    isCollapsed: this.props.openExpanded,
    isLoading: false
  };

  handleClick = (e) => {
    this.setState({ isCollapsed: !this.state.isCollapsed });
  };

  _footer = () => {
    if (this.props.footer)
      return <Card.Footer>{this.props.footer}</Card.Footer>;
    else return null;
  };

  renderLoading = () => {
    return <LoadingSpinner className="d-flex justify-content-center " />;
  };

  renderContent = () => {
    if (this.props.isLoading === true) {
      return this.renderLoading();
    } else {
      return (<div>{this.props.children}</div>)
    }
  }

  render() {
    const { current } = this.state;
    return (
      <Card>
        <Card.Header
          className="fuseHover clickable bg-primary text-light"
          onClick={(e) => {
            this.handleClick(e);
          }}
        >
          <strong>{this.props.title}</strong>
          <div className="float-right"><i className={(this.state.isCollapsed) ? "fa fa-chevron-down fa-lg" : "fa fa-chevron-up fa-lg"}/></div>
        </Card.Header>
        <Card.Body hidden={this.state.isCollapsed}>
          {this.renderContent()}
        </Card.Body>
        {this._footer()}
      </Card>
    );
  }
}

export default FuseCollapsiblePanel;
